import { differenceInDays, isSameMonth } from 'date-fns';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { SurveyType } from '@web/components/survey/types';

// PSAT has been disabled indefinitely but it was requested
// that we leave it in code as it might make a comeback
// 0 - January, 3 - April etc.
const NPS_RATING_MONTHS = [0, 3, 6, 9];
const PSAT_RATING_MONTHS = [];
// run survey for 13 days (14th - 27th) of the rating months
const RATING_START_DAY_IN_MONTH = 7;
const RATING_END_DAY_IN_MONTH = 20;

const MIN_EXPERIENCE_DAYS = 10;
const NPS_FLAG_KEY = 'npsRateDate';

export function shouldDisplaySatisfactionSurvey(
  user: AuthUserType,
  surveyType: SurveyType
): boolean {
  return (
    user.isManager &&
    shouldDisplayByDate(surveyType) &&
    shouldDisplayByOrgExperience(user) &&
    shouldDisplayByLastRate(user)
  );
}

function shouldDisplayByDate(surveyType: SurveyType): boolean {
  return getSurveyTypeByDate() === surveyType;
}

function shouldDisplayByOrgExperience(user: AuthUserType): boolean {
  const daysSinceOrgCreated = differenceInDays(new Date(), new Date(user.org.createdAt));
  const daysSinceUserCreated = differenceInDays(new Date(), new Date(user.createdAt));

  return daysSinceOrgCreated >= MIN_EXPERIENCE_DAYS && daysSinceUserCreated >= MIN_EXPERIENCE_DAYS;
}

function shouldDisplayByLastRate(user: AuthUserType): boolean {
  const lastRate = getLastRateDate(user);
  if (!lastRate) {
    return true;
  }

  const currentDate = new Date();
  return !isSameMonth(currentDate, lastRate);
}

export const getSurveyTypeByDate = (): SurveyType | null => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();

  if (NPS_RATING_MONTHS.includes(currentMonth) && isRatingDay(currentDate)) {
    return SurveyType.nps;
  }

  if (PSAT_RATING_MONTHS.includes(currentMonth) && isRatingDay(currentDate)) {
    return SurveyType.psat;
  }

  return null;
};

function isRatingDay(date: Date) {
  const dayInMonth = date.getDate();

  return dayInMonth >= RATING_START_DAY_IN_MONTH && dayInMonth <= RATING_END_DAY_IN_MONTH;
}

function getLastRateDate(user: AuthUserType): Date | null {
  const lastNpsDate = user.settings.clientFlags[NPS_FLAG_KEY];
  return lastNpsDate ? new Date(lastNpsDate) : null;
}
